<div class="open-menu" (click)="navbarOpenResp=true; navbarOpen=true; selectMasivo('mainMenu','');">
    <i class="las la-bars"></i>
</div>

<div class="wrapper">
    <!-- Sidebar Holder -->
    <div id="sidebar" [class.active]="navbarOpen">
        <!--<aside class="sidebar sidebar-frente" [class.sidebar-free]="isActiveMasivo('mainMenu')" [class.disabled]="selectedMessage">-->
        <div *ngIf="navbarOpen" class="close-menu" (click)="navbarOpenResp=false; navbarOpen=false;">
            <i class="las la-times"></i>
        </div>
        <div *ngIf="navbarOpen" class="sidebar-fondo">
        </div>

        <aside class="sidebar-free">
    
            <header class="site-logo" [class.free]="esGratis">
                <span class="icon-free" #recibirValorBloquear>
                    <img *ngIf="!isActiveMasivo('mainMenu')" class="navbar-default" src='../../assets/img/noe-free/logo-menu.png' style="width: 57px; display: block; margin: 0 auto; margin-left: 11px;">
                    <img *ngIf="isActiveMasivo('mainMenu')" class="navbar-default" style="width: 100%; height: 95px; display: block; margin: 0 auto; margin-left: 5px; padding-bottom: 10px !important; padding-top: 10px;"
                        [src]="logoSidebar"
                        alt="NOE - Notificaciones Electrónicas">
                    <img class="navbar-resp" style="width: 100%; height: 95px; display: block; margin: 0 auto; margin-left: 5px; padding-bottom: 10px !important; padding-top: 10px;"
                        [src]="logoSidebar"
                        alt="NOE - Notificaciones Electrónicas">
                </span>
    
                <!--<span class="site-logo1__logo-container">
                    <img 
                        [src]="logoSidebar"
                        alt="NOE - Notificaciones Electrónicas">
                </span>-->
    
                <div class="free-icon tag success" style="background-color: #27bb62c4;color: white;" *ngIf="esGratis">VERSION GRATUITA</div>
            </header>
    
            <!-- Usuarios -->
            <ng-container *ngIf="rol !== 'receptor' && esGratis">
                <ng-container *ngFor="let modulo of opciones; index as i;">
    
                    <div class="aside-section">
                        <!--<div class="aside-section" *ngIf="modulo.enabled">-->
    
                        <div class="icon">
                            <i *ngIf="i === 0" class="las la-tools"></i>
                            <i *ngIf="i === 1" class="las la-pen"></i>
                            <i *ngIf="i === 2" class="las la-user-cog"></i>
                            <i *ngIf="i === 3" class="las la-bell"></i>
                            <i *ngIf="i === 4" class="las la-user-friends"></i>
                        </div>
    
                        <div class="element">
                            <h3 class="aside-title" appMenuDropdown>
                                <!-- {{modulo.name}}-->
                                <div *ngIf="(modulo.name != 'administrador' || modulo.name != 'notificaciones' || modulo.name != 'mantenimiento') ">
                                    {{modulo.name}}&nbsp;
    
                                </div>
                                <div *ngIf="(modulo.name == 'administrador' || modulo.name == 'notificaciones') && esGratis">
                                    <em class="free-icon tag success" style="background-color: #27bb62c4;color: white;">premium</em>
                                </div>
    
                                <div *ngIf="(modulo.name != 'administrador' && modulo.name != 'notificaciones')" class="aside-title__button">
                                    <span class="arrow"></span>
                                </div>
    
                            </h3>
    
                            <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                <ng-container *ngFor="let hijo of modulo.list_options">
                                    <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' ">
                                        <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                            {{hijo.name}} 
                                            </a>
                                    </li>
                                    <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'">
                                        <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                {{hijo.name}} 
                                            </a>
                                    </li>
                                    <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'">
                                        <a (click)="onnavigation.emit()" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                {{hijo.name}} 
                                                <span 
                                                
                                                    *ngIf="
                                                        (hijo.code_child == '0000202' && hayPendientes) ||
                                                        (hijo.code_child == '0000204' && hayEnProceso) ||
                                                        (hijo.code_child == '0000402' && porNotificar)" 
                                                    app-dot-new
                                                ></span>
                                            </a>
                                    </li>
                                </ng-container>
                            </ul>
    
                        </div>
    
                    </div>
                </ng-container>
            </ng-container>
    
            <!-- Usuarios -->
            <ng-container *ngIf="rol !== 'receptor' && !esGratis">
                <ng-container *ngFor="let modulo of opciones; index as i;">
    
                    <!-- <div class="aside-section">-->
                    <div class="aside-section" *ngIf="modulo.enabled">
    
                        <!--<div class="icon">
                            <i *ngIf="i === 0" class="las la-tools"></i>
                            <i *ngIf="i === 1" class="las la-pen"></i>
                            <i *ngIf="i === 2" class="las la-user-cog"></i>
                            <i *ngIf="i === 3" class="las la-bell"></i>
                            <i *ngIf="i === 4" class="las la-user-friends"></i>
                        </div>-->
    
                        <div class="icon-free">
                            
                            <div (click)="selectMasivo('mainMenu');" [class.active]="isActiveMasivo('mainMenu')">
                                <div class="d-flex justify-content-center">
                                    <div class="col-button-resp-menu navbar-default">
                                    
                                        <div copilot [copilot-template]="step1" [copilot-step]="6">
                                            <i *ngIf="modulo.code_child === '0000006'">
                                                <div *ngIf="verIconDashboard" class="borde-icon" [class.menu-desplegable-borde]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                    <img src='../../assets/img/noe-free/icon-dashboard.png' style="width: 64px; display: block; margin: 0 auto; padding: 7px 3px 7px 3px; margin-left: 0px;">
                                                </div>
                                                <div *ngIf="!verIconDashboard" class="borde-icon-disabled" [class.menu-desplegable-borde1]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                    <img src='../../assets/img/noe-free/icon-dashboard-gray.png' style="width: 64px; display: block; margin: 0 auto; padding: 7px 3px 7px 3px; margin-left: 0px;">
                                                </div>
                                            </i>
                                        </div>
                                        <i *ngIf="modulo.code_child === '0000007'">
                                            <div *ngIf="verIconDocumentos" class="borde-icon" [class.menu-desplegable-borde]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-documentos.png' style="width: 62px; display: block; margin: 0 auto; padding: 10px 9px 10px 9px; margin-left: 0px;">
                                            </div>
    
                                            <div *ngIf="!verIconDocumentos" class="borde-icon-disabled" [class.menu-desplegable-borde1]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-documentos-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 10px 9px 10px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000008'">
                                            <div *ngIf="verIconContactos" class="borde-icon" [class.menu-desplegable-borde]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-contactos.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconContactos" class="borde-icon-disabled" [class.menu-desplegable-borde1]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-contactos-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000009'">
                                            <div *ngIf="verIconConfiguracion" class="borde-icon" [class.menu-desplegable-borde]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-configuracion.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconConfiguracion" class="borde-icon-disabled" [class.menu-desplegable-borde1]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-configuracion-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000010'">
                                            <div *ngIf="verIconMarket" class="borde-icon" [class.menu-desplegable-borde]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-market.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconMarket" class="borde-icon-disabled" [class.menu-desplegable-borde1]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-market-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000011'">
                                            <div *ngIf="verIconUsuarioFree" class="borde-icon" [class.menu-desplegable-borde]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-usuariosfree.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconUsuarioFree" class="borde-icon-disabled" [class.menu-desplegable-borde1]="isActiveMasivo('mainMenu')" (click)="toggleNavbar()">
                                                <img src='../../assets/img/noe-free/icon-usuariosfree-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                    </div>

                                    <div class="col-button-resp-menu navbar-resp">
                                    
                                        <div copilot [copilot-template]="step1" [copilot-step]="6">
                                            <i *ngIf="modulo.code_child === '0000006'">
                                                <div *ngIf="verIconDashboard" class="menu-desplegable-borde">
                                                    <img src='../../assets/img/noe-free/icon-dashboard.png' style="width: 64px; display: block; margin: 0 auto; padding: 7px 3px 7px 3px; margin-left: 0px;">
                                                </div>
                                                <div *ngIf="!verIconDashboard" class="menu-desplegable-borde1">
                                                    <img src='../../assets/img/noe-free/icon-dashboard-gray.png' style="width: 64px; display: block; margin: 0 auto; padding: 7px 3px 7px 3px; margin-left: 0px;">
                                                </div>
                                            </i>
                                        </div>
                                        <i *ngIf="modulo.code_child === '0000007'">
                                            <div *ngIf="verIconDocumentos" class="menu-desplegable-borde">
                                                <img src='../../assets/img/noe-free/icon-documentos.png' style="width: 62px; display: block; margin: 0 auto; padding: 10px 9px 10px 9px; margin-left: 0px;">
                                            </div>
    
                                            <div *ngIf="!verIconDocumentos" class="menu-desplegable-borde1">
                                                <img src='../../assets/img/noe-free/icon-documentos-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 10px 9px 10px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000008'">
                                            <div *ngIf="verIconContactos" class="menu-desplegable-borde">
                                                <img src='../../assets/img/noe-free/icon-contactos.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconContactos" class="menu-desplegable-borde1">
                                                <img src='../../assets/img/noe-free/icon-contactos-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000009'">
                                            <div *ngIf="verIconConfiguracion" class="menu-desplegable-borde">
                                                <img src='../../assets/img/noe-free/icon-configuracion.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconConfiguracion" class="menu-desplegable-borde1">
                                                <img src='../../assets/img/noe-free/icon-configuracion-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000010'">
                                            <div *ngIf="verIconMarket" class="menu-desplegable-borde">
                                                <img src='../../assets/img/noe-free/icon-market.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconMarket" class="menu-desplegable-borde1">
                                                <img src='../../assets/img/noe-free/icon-market-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                        <i *ngIf="modulo.code_child === '0000011'">
                                            <div *ngIf="verIconUsuarioFree" class="menu-desplegable-borde">
                                                <img src='../../assets/img/noe-free/icon-usuariosfree.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                            <div *ngIf="!verIconUsuarioFree" class="menu-desplegable-borde1">
                                                <img src='../../assets/img/noe-free/icon-usuariosfree-gray.png' style="width: 62px; display: block; margin: 0 auto; padding: 14px 9px 14px 9px; margin-left: 0px;">
                                            </div>
                                        </i>
                                    </div>

                                    <div class="menu-desplegable">
                                        <div class="cont-menu" [ngClass]="{active: isActiveMasivo('subMenu')}" (click)="selectMasivo('subMenu', $event);">
                                        
                                            <div class="element">
                                                <h3 class="aside-title" appMenuDropdown>
                                                    <!--<span *ngIf="modulo.code_child !== '0000010'" style="position: absolute; margin-left: 55px; padding: 24px 60px 24px 15px">{{modulo.name}}</span>-->    
                                                    <span *ngIf="modulo.code_child === '0000001'" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px;"></span> 
                                                    <span *ngIf="modulo.code_child === '0000006'" (click)="activeDropdown(modulo.code_child);" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px" [routerLink]="'/'">Inicio</span> 
                                                    <span *ngIf="modulo.code_child === '0000007'" (click)="activeDropdown(modulo.code_child);" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px">Mis documentos</span> 
                                                    <span *ngIf="modulo.code_child === '0000008'" (click)="activeDropdown(modulo.code_child);" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px">Contactos</span> 
                                                    <span *ngIf="modulo.code_child === '0000009'" (click)="activeDropdown(modulo.code_child);" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px">Configuraciones</span> 
                                                    <span *ngIf="modulo.code_child === '0000010'" (click)="activeDropdown(modulo.code_child);" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px" [routerLink]="'/' + modulo.action">Market</span>      
                                                    <span *ngIf="modulo.code_child === '0000011'" (click)="activeDropdown(modulo.code_child);" style="position: absolute; margin-left: 55px; padding: 24px 0px 24px 15px" [routerLink]="'/' + modulo.action">Bandeja de usuarios</span>      
                                                    <div class="aside-title__button" style="margin-left: 215px;">
                                                        <span *ngIf="modulo.code_child != '0000006' && modulo.code_child != '0000010' && modulo.code_child != '0000001' && modulo.code_child != '0000011'" class="arrow"></span>
                                                    </div>
                                                </h3>
                            
                                                <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                                    <ng-container *ngFor="let hijo of modulo.list_options">
                                                        <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' " (click)="navbarOpen=false; selectMasivo('subMenu', $event)">
                                                            <a (click)="alertaAviso(modulo.action,hijo.action);" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                                <i class="las la-angle-right menu-arrow"></i> {{hijo.name}}
                                                                </a>
                                                        </li>
                                                        <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'" (click)="navbarOpen=false; selectMasivo('subMenu', $event)">
                                                            <a (click)="alertaAviso(modulo.action,hijo.action);" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                                <i class="las la-angle-right menu-arrow"></i> {{hijo.name}} 
                                                                </a>
                                                        </li>
                                                        <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'" (click)="navbarOpen=false; selectMasivo('subMenu', $event)">
                                                            <a (click)="onnavigation.emit(); sharedTitleSession(hijo.action); activeDropdown(hijo.code_child);" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                                <i class="las la-angle-right menu-arrow"></i> {{hijo.name}}
                                                                    <span 
                                                                    
                                                                        *ngIf="
                                                                            (hijo.code_child == '0000202' && hayPendientes) ||
                                                                            (hijo.code_child == '0000204' && hayEnProceso) ||
                                                                            (hijo.code_child == '0000402' && porNotificar)" 
                                                                        app-dot-new
                                                                    ></span>
                                                                </a>
                                                        </li>
                                                    </ng-container>
                                                </ul>
                            
                                            </div>
    
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <ng-template #step1>
                                <div class="copilot-custom-free-1">
                                    <div class="content-title">
                                        <h3>Aquí encontrarás las distintas opciones disponibles.</h3>
                                    </div>
                                    <div class="footer-btn">
                                        <div class="num-step">1/7</div>
                                        <div>
                                            <button class="btn-omitir" (click)="omitir();" type="button">Omitir</button>
                                            <button (click)="siguiente(7);" type="button">Siguiente</button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
    
                            <!--<div class="dropdown">
                                <i class="dropbtn" *ngIf="i === 0" class="las la-tools"></i>
                                <div class="dropdown-content">
                                    <h3 class="aside-title" appMenuDropdown>
                                        {{modulo.name}}
                
                                        <div class="aside-title__button">
                                            <span class="arrow"></span>
                                        </div>
                                    </h3>
    
                                    <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                        <ng-container *ngFor="let hijo of modulo.list_options">
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' ">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'">
                                                <a (click)="onnavigation.emit()" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                        {{hijo.name}} 
                                                        <span 
                                                        
                                                            *ngIf="
                                                                (hijo.code_child == '0000202' && hayPendientes) ||
                                                                (hijo.code_child == '0000204' && hayEnProceso) ||
                                                                (hijo.code_child == '0000402' && porNotificar)" 
                                                            app-dot-new
                                                        ></span>
                                                    </a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
    
                            <div class="dropdown">
                                <i class="dropbtn" *ngIf="i === 1" class="las la-pen"></i>
                                <div class="dropdown-content">
                                    <h3 class="aside-title" appMenuDropdown>
                                        {{modulo.name}}
                
                                        <div class="aside-title__button">
                                            <span class="arrow"></span>
                                        </div>
                                    </h3>
    
                                    <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                        <ng-container *ngFor="let hijo of modulo.list_options">
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' ">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'">
                                                <a (click)="onnavigation.emit()" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                        {{hijo.name}} 
                                                        <span 
                                                            *ngIf="
                                                                (hijo.code_child == '0000202' && hayPendientes) ||
                                                                (hijo.code_child == '0000204' && hayEnProceso) ||
                                                                (hijo.code_child == '0000402' && porNotificar)" 
                                                            app-dot-new
                                                        ></span>
                                                    </a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
    
                            <div class="dropdown">
                                <i class="dropbtn" *ngIf="i === 2" class="las la-user-cog"></i>
                                <div class="dropdown-content">
                                    <h3 class="aside-title" appMenuDropdown>
                                        {{modulo.name}}
                
                                        <div class="aside-title__button">
                                            <span class="arrow"></span>
                                        </div>
                                    </h3>
    
                                    <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                        <ng-container *ngFor="let hijo of modulo.list_options">
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' ">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'">
                                                <a (click)="onnavigation.emit()" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                        {{hijo.name}} 
                                                        <span 
                                                            *ngIf="
                                                                (hijo.code_child == '0000202' && hayPendientes) ||
                                                                (hijo.code_child == '0000204' && hayEnProceso) ||
                                                                (hijo.code_child == '0000402' && porNotificar)" 
                                                            app-dot-new
                                                        ></span>
                                                    </a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
    
                            <div class="dropdown">
                                <i class="dropbtn" *ngIf="i === 3" class="las la-bell"></i>
                                <div class="dropdown-content">
                                    <h3 class="aside-title" appMenuDropdown>
                                        {{modulo.name}}
                
                                        <div class="aside-title__button">
                                            <span class="arrow"></span>
                                        </div>
                                    </h3>
    
                                    <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                        <ng-container *ngFor="let hijo of modulo.list_options">
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' ">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'">
                                                <a (click)="onnavigation.emit()" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                        {{hijo.name}} 
                                                        <span  
                                                            *ngIf="
                                                                (hijo.code_child == '0000202' && hayPendientes) ||
                                                                (hijo.code_child == '0000204' && hayEnProceso) ||
                                                                (hijo.code_child == '0000402' && porNotificar)" 
                                                            app-dot-new
                                                        ></span>
                                                    </a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
    
                            <div class="dropdown">
                                <i class="dropbtn" *ngIf="i === 4" class="las la-user-friends"></i>
                                <div class="dropdown-content">
                                    <h3 class="aside-title" appMenuDropdown>
                                        {{modulo.name}}
                
                                        <div class="aside-title__button">
                                            <span class="arrow"></span>
                                        </div>
                                    </h3>
    
                                    <ul *ngIf="modulo.list_options.length > 0" (click)="$event.stopPropagation();">
                                        <ng-container *ngFor="let hijo of modulo.list_options">
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000104' ">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child === '0000301'">
                                                <a (click)="alertaAviso(modulo.action,hijo.action)" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}" style="cursor:pointer;" [readonly]="true">
                                                        {{hijo.name}} 
                                                    </a>
                                            </li>
                                            <li class="nav-item" *ngIf="hijo.enabled && hijo.code_child !== '0000104' && hijo.code_child !== '0000301'">
                                                <a (click)="onnavigation.emit()" [routerLink]="'/' + modulo.action + '/' + hijo.action" git routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                                        {{hijo.name}} 
                                                        <span
                                                            *ngIf="
                                                                (hijo.code_child == '0000202' && hayPendientes) ||
                                                                (hijo.code_child == '0000204' && hayEnProceso) ||
                                                                (hijo.code_child == '0000402' && porNotificar)" 
                                                            app-dot-new
                                                        ></span>
                                                    </a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>-->
    
                        </div>
    
    
    
                    </div>
                </ng-container>
            </ng-container>
    
    
            <!-- Receptores -->
            <ng-container *ngIf="rol === 'receptor'">
                <div class="aside-section">
    
                    <div class="icon">
                        <i class="las la-email"></i>
                    </div>
    
                    <div class="element">
                        <h3 class="aside-title" appMenuDropdown>
                            Receptor
                            <div class="aside-title__button">
                                <span class="arrow"></span>
                            </div>
                        </h3>
    
                        <ul (click)="$event.stopPropagation();">
                            <li class="nav-item">
                                <a [routerLink]="'/receptor/bandeja-de-entrada'" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                    Bandeja de entrada
                                    <span *ngIf="hayDocumentosReceptor" app-dot-new></span>
                                </a>
                            </li>
                        </ul>
                    </div>
    
                </div>
    
                <div class="aside-section" *ngIf="noHayTiposDeFirma" >
    
                    <div class="icon">
                        <i class="las la-pen-nib"></i>
                    </div>
    
                    <div class="element">
                        <h3 class="aside-title" appMenuDropdown>
                            Panel de Firmas
                            <div class="aside-title__button">
                                <span class="arrow"></span>
                            </div>
                        </h3>
    
                        <ul (click)="$event.stopPropagation();">
                            <li class="nav-item">
                                <a [routerLink]="'/panel-de-firmas/configurar-rubrica'" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                    Configurar Rúbrica
                                </a>
                            </li>
                            <!--RQ Mostrar para receptores 06-12-2022 -->
                            <li class="nav-item">
                                <a [routerLink]="'/panel-de-firmas/descarga-sign-fast-client'" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
                                    Descarga Sign Fast Client
                                </a>
                            </li>
                        </ul>
                    </div>
    
                </div>
    
            </ng-container>
    
            <ngx-wrapper-copilot></ngx-wrapper-copilot>
        </aside>

    </div>
        
    <!-- Page Content Holder -->
    <div id="content">

      <app-topbar-modal (mouseenter)="navbarOpen=false; selectMasivo('subMenu', $event)" (click)="navbarOpen=false; selectMasivo('subMenu', $event)"></app-topbar-modal>

      <div class="page-content" (mouseenter)="navbarOpen=false; selectMasivo('subMenu', $event)" (click)="navbarOpen=false; selectMasivo('subMenu', $event)">
        <router-outlet></router-outlet>
      </div>
      
    </div>
</div>

<app-modal #modalEmpecemos class="modalEmpecemos" [hide-footer]="true">

    <div *ngIf="verEmpezar && !verComenzar" class="double-row">
        <form [formGroup]="empecemosForm" class="empecemos-form" (ngSubmit)="empecemos()">

            <label class="text-registro">¡Empecemos!</label>  
            <label class="sub-registro">Primero, vayamos a lo básico. Completa tus datos faltantes:</label>
            <div class="double-row" style="grid-gap: 8px;">
                <div class="input-user-container">
                    <app-input
                        type="text" 
                        label="Nombre" 
                        formControlName="nombre"
                        placeholder=""
                    ></app-input>
                </div>
                <div class="input-user-container">
                    <app-input
                        type="text" 
                        label="Apellido" 
                        formControlName="apellido"
                        placeholder=""
                    ></app-input>
                </div>
            </div>

            <div class="input-pass-container">
                <label>Número de teléfono</label>
                <div class="double-row-perfil-select">
                    <app-input type="select" formControlName="nationalType" [selectOptions]="countries" [selectOptionsName]="'optionName'" [selectOptionsKey]="'code'"></app-input>
                    <app-input type="number" formControlName="telefono" placeholder="802345678"></app-input>
                </div>
            </div>

            <div class="input-user-container">
                <label [class.error]="existeDni">Documento de identificación</label>
                <div class="double-row-registrate">
                    <div class="input-user-container">
                        <select type="text" [(ngModel)]="theValue" [class.error]="(empecemosForm.controls['selectDni'].touched && !theValue) || existeDni" (change)="getChangeDoc($event.target.value)" formControlName="selectDni">
                            <option disabled selected>Seleccione</option>
                            <option *ngFor="let o of options" [value]="o.name">
                                {{o.name}}  
                            </option>
                        </select>
                        <div class="error-block" *ngIf="empecemosForm.controls['selectDni'].invalid && empecemosForm.controls['selectDni'].touched && this.idDocSelect == null">
                            <p>Este campo es obligatorio</p>
                        </div>
                    </div>

                    <div class="input-user-container">
                        <app-input [class.error]="existeDni" 
                            type="text" 
                            formControlName="dni"
                            placeholder="73214243"
                        ></app-input>
                    </div>
                </div>
                <div *ngIf="existeDni && this.idDocSelect != null" class="error-block-dni">
                    {{ validacionDni }}
                </div>
            </div>

            <button *ngIf="!loading" type="submit"><strong>Siguiente</strong></button>

            <button *ngIf="loading" class="disabled loading" type="submit">
                <strong>Siguiente</strong>
            </button>

        </form> 

        <img class="img-onboarding" src='../../assets/img/noe-free/empecemos.png' style="width: 448px; display: block; margin: 0 auto;">
        <div class="right"></div>
    </div>
    
    <div *ngIf="!verEmpezar && verComenzar" class="double-row">
        <div class="empecemos-form">
    
            <label class="text-registro2">Firmar nunca fue tan fácil</label>  
            <label class="sub-registro2">Olvídate de las hojas y cambiate a la comunidad que firma digitalmente.</label>
            <div>
                <li class="nav-item">
                    <a style="cursor:pointer;">
                        <img src='../../assets/img/noe-free/papel.png' style="width: 17px; display: inline-block; margin: 0 auto; margin-right: 10px; margin-bottom: -2px;">
                        Ahorras un 70 % más de papel.
                    </a>
                </li>
                
                <li class="nav-item">
                    <a style="cursor:pointer;">
                        <img src='../../assets/img/noe-free/global.png' style="width: 17px; display: inline-block; margin: 0 auto; margin-right: 10px; margin-bottom: -2px;">
                        Puedes firmar desde cualquier parte.
                    </a>
                </li>
                <li class="nav-item">
                    <a style="cursor:pointer;">
                        <img src='../../assets/img/noe-free/seguridad.png' style="width: 17px; display: inline-block; margin: 0 auto; margin-right: 10px; margin-bottom: -2px;">
                        Almacena tus documentos en la nube
                    </a>
                </li>

                <li class="nav-item">
                    <a style="cursor:pointer;">
                        <img src='../../assets/img/noe-free/usuario.png' style="width: 17px; display: inline-block; margin: 0 auto; margin-right: 10px; margin-bottom: -2px;">
                        Plataforma adaptable a cualquier tipo<br>
                        <span class="text-mr">de usuario y/o empresa</span>
                    </a>
                </li>
            </div>
    
            <button *ngIf="!loading" (click)="cerrarModalEmpecemos();" type="submit"><strong>Comenzar el tutorial</strong></button>
    
            <button *ngIf="loading" class="disabled loading" type="submit">
                <strong>Comenzar el tutorial</strong>
            </button>
        </div>
    
        <img class="img-onboarding" src='../../assets/img/noe-free/comenzar.png' style="width: 448px; display: block; margin: 0 auto;">
        <div class="right"></div>
    </div>


</app-modal>

<app-modal-inicio #modalInicioTerminos titleModal="Términos y Condiciones" (onconfirm)="accept = true" (click)="handleAcceptConfirm()" [scroller]="true">
    <app-terminos-y-condiciones></app-terminos-y-condiciones>        
</app-modal-inicio>

<app-modal-lectura #modalLecturaTerminos titleModal="Términos y Condiciones" [scroller]="true">
    <app-terminos-y-condiciones></app-terminos-y-condiciones>
</app-modal-lectura>

<!-- Modal Caducidad Contraseña -->
<app-modal-inicio #modalCaducidadContrasena (onclose)="passForm.reset()" titleModal="Contraseña Caducada" [hide-footer]="true">
        <form [formGroup]="passForm" (submit)="changePassword($event)" *ngIf="passForm">
            <p>La contraseña actual a caducado, por favor realizar el cambio de su contraseña.</p><br>
            <app-input type="password" formControlName="oldPass" label="Contraseña Actual" [required]="true"></app-input>
            <app-input type="password" formControlName="password" label="Nueva Contraseña" [required]="true"></app-input>
            <app-input type="password" formControlName="confirm" label="Confirmar Contraseña" [required]="true"></app-input>
            <p class="error-message" *ngIf="passForm.errors?.mismatch">Las contraseñas deben coincidir</p>
            <app-password-validators [form]="passForm" [validators]="this.validators.validators"></app-password-validators>
    
            <div class="form-footer">
                <button *ngIf="!pLoading" class="btn" type="submit">Confirmar</button>
    
                <button *ngIf="pLoading" class="btn disabled loading" type="submit"> Confirmando </button>
            </div>
        </form>
</app-modal-inicio>


<!-- Modal Roles -->
<app-modal #modalObtenerPremium titleModal="CAMBIARME A CUENTA PREMIUM" [hide-footer]="true">

    <em>Opciones solo para la versión Pagada, solicitar ahora</em>

    <div class="form-footer">
        <button class="btn success" (click)="confirmarObtenerPremium()" [class.loading]="modalCambiarmeCuentaPagoLoading">Quiero que me contacten</button>
    </div>
</app-modal>